import { Component, OnInit, Inject } from '@angular/core';
import { isNullOrUndefined } from 'util';
import { Store, select } from '../../../../../node_modules/@ngrx/store';
import { SelectCountries } from 'app/profile/store/app.selector';
import { SupplierAddress } from 'app/profile/models/supplier.model';
import { MasterDataState } from 'app/profile/store/state/masterdata.state';
import { Country } from 'app/profile/models/masterdata.model';
import { TslDialogRef, TSL_DIALOG_DATA } from '@tesla/ng-tds';

@Component({
  selector: 'app-address-suggestion',
  templateUrl: './address-suggestion.component.html',
  styleUrls: ['./address-suggestion.component.scss']
})
export class AddressSuggestionComponent implements OnInit {
  disableAccept: boolean;
  favoriteSuggestion: any;
  countries: Country[];
  constructor(
    public dialogRef: TslDialogRef<AddressSuggestionComponent>,
    @Inject(TSL_DIALOG_DATA) public predictions: any[],
    private store: Store<MasterDataState>
  ) { }

  ngOnInit() {
    this.disableAccept = true;
    this.store.pipe(select(SelectCountries)).subscribe(x => this.countries = x);
  }

  acceptSuggestion() {
    if (this.favoriteSuggestion) {
      const result: SupplierAddress = new SupplierAddress();
      const parseaddress: Array<string> = this.favoriteSuggestion.split(',');
      if (parseaddress.length === 4) {
        result.Street1 = parseaddress[0];
        result.City = parseaddress[1].trim();
        result.CountryCode = this.getCountryCode(parseaddress[3].trim());

        if (!isNullOrUndefined(parseaddress[2].trim().split(' ')[0])) {
          result.State = parseaddress[2].trim().split(' ')[0];
        }

        if (!isNullOrUndefined(parseaddress[2].trim().split(' ')[1])) {
          result.ZipCode = parseaddress[2].trim().split(' ')[1];
        }
      } else if (parseaddress.length === 5) {
        result.Street1 = parseaddress[0];
        result.Street2 = parseaddress[1].trim();
        result.City = parseaddress[2].trim();
        result.CountryCode = this.getCountryCode(parseaddress[4].trim());

        if (!isNullOrUndefined(parseaddress[3].trim().split(' ')[0])) {
          result.State = parseaddress[3].trim().split(' ')[0];
        }

        if (!isNullOrUndefined(parseaddress[3].trim().split(' ')[1])) {
          result.ZipCode = parseaddress[3].trim().split(' ')[1];
        }
      }
      this.dialogRef.close(result);
    }
  }

  getCountryCode(country) {
    return this.countries.find(x => x.name === country || x.abbreviation === country).abbreviation;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
